<template>
  <div class="section-content" :class="{ 'section-content--menu-active': menuOpenCount > 0 }">
    <div v-if="events.length === 0" class="empty-state">
      {{ $t('publicEvents.noScheduledEvents') }}
    </div>

    <template
      v-for="(event, index) in events"
      :key="index"
    >
      <!-- League name header for league events in custom sections -->
      <div
        v-if="showLeagueHeader && isLeagueEvent(event) && event._league?.title"
        class="league-header"
      >
        <img
          v-if="event._league?.imageUrl"
          :src="`${UPLOADS}/leagues/h200-${event._league.imageUrl}`"
          alt=""
          class="league-header-logo"
        />
        <span class="league-header-title">{{ event._league.title }}</span>
      </div>

      <component
        :is="getEventTileComponent(event.type)"
        :showEdit="!hideActions"
        :showMenu="pinnedActions"
        :showPinnedActions="pinnedActions && !!event.pin"
        :event="event"
        :fullDate="true"
        :showLeagueLogo="showLeagueLogo"
        :showTeamLogos="showTeamLogos"
        :showLeagueHeader="showLeagueHeader"
        :hideActions="hideActions && !event._league"
        @unpinEvent="$emit('unpinEvent', $event)"
        @deleteEvent="$emit('deleteEvent', $event)"
        @cancelEvent="$emit('cancelEvent', $event)"
        @editEvent="$emit('editEvent', $event)"
        @navigate="$emit('navigate', event)"
        @menuOpen="menuOpenCount++"
        @menuClose="menuOpenCount--"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { IEvent } from '@/types'
import { useEventTileResolver } from '@/composables/useEventTileResolver'

const UPLOADS = import.meta.env.VITE_UPLOADS || 'http://localhost:3000/uploads'

const props = defineProps<{
  events: IEvent[]
  showLeagueLogo?: boolean
  showTeamLogos?: boolean
  showLeagueHeader?: boolean
  hideActions?: boolean
  pinnedActions?: boolean
}>()

defineEmits(['unpinEvent', 'deleteEvent', 'cancelEvent', 'editEvent', 'navigate'])

const menuOpenCount = ref(0)

const { getEventTileComponent } = useEventTileResolver()

const isLeagueEvent = (event: IEvent) => {
  return event.type === 'league-match' || event.type === 'friendly-match'
}
</script>

<style scoped>
.empty-state {
  padding: 48px 16px;
  text-align: center;
  color: rgba(var(--v-theme-sheetText), 0.4);
  font-size: 0.9rem;
}

.league-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 4px;
  color: rgba(var(--v-theme-sheetText), 0.6);
  font-size: 0.8rem;
  font-weight: 500;
}

.league-header-logo {
  height: 18px;
  width: auto;
  object-fit: contain;
}

.league-header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
